export default __webpack_public_path__ + "static/media/regulatory--end-of-tractors-only--g1.bbb8849f.png";